import { render, staticRenderFns } from "./ComponentDetail.vue?vue&type=template&id=707ba6e7&"
import script from "./ComponentDetail.vue?vue&type=script&lang=js&"
export * from "./ComponentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports